<template>
  <div v-if="ncstraining" class="mx-auto">
    <mdb-tbl sm hover>
      <mdb-tbl-head>
        <tr class="title" >
          <th>능력단위 분류번호/능력단위명</th>
          <th style="width:60px">수준</th>
          <th style="width:60px">시간</th>
          <th>능력단위 요소 코드/능력단위 요소명</th>
        </tr>
      </mdb-tbl-head>
      <mdb-tbl-body>
        <tr v-for="(lecture, ix) in ncstraining.ncsSpecials" :key="ix">
          <td>
            <div class="clearfix">
              <div class="float-left"><span @click="$emit('lecture-edit', lecture)" class="title bolder pointer">{{lecture.name}}/{{lecture.code}}</span></div>
              <div class="float-right text-right">
                <mdb-btn icon="times" class="p-1" color="danger" @click="onDeleteLecture(ix)"/>
              </div>
            </div>
          </td>
          <td>{{lecture.level}}</td>
          <td>{{lecture.hours}}</td>
          <td>
            <div v-for="(unit, ux) in lecture.units" :key="ux">
              {{unit.name}}/{{unit.code}} <mdb-badge color="primary">{{unit.content.length}}</mdb-badge>
            </div>
          </td>
        </tr>
      </mdb-tbl-body>
    </mdb-tbl>
    <mdb-btn icon="plus" class="py-1 px-2" @click="onAddLecture">능력단위 추가</mdb-btn>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue'
import NcsTraining from '@/models/NcsTraining'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  name: 'StaffNcsTrainingLectureView',
  components: { mdbTbl, mdbTblHead, mdbTblBody },
  props: ['ncstraining'],
  data: () => ({
    TAG: 'StaffNcsTrainingLectureView'
  }),
  methods: {
    onBack () {
      this.$router.back()
    },
    async onSave () {
      if (!confirm('저장할까요?')) return
      this.ncstraining = await this.ncstraining.save()
    },
    async onDelete () {
      if (!confirm('삭제할까요?')) return
      await this.ncstraining.delete()
      this.$router.back()
    },
    onAddLecture () {
      const lecture = {
        name: '새 능력단위',
        code: '새 코드',
        level: 1,
        horus: 0,
        units: [
          { code: '', name: '', content: ['', '', ''] },
          { code: '', name: '', content: ['', '', ''] },
          { code: '', name: '', content: ['', '', ''] }
        ]
      }
      this.ncstraining.ncsSpecials.push(lecture)
    },
    async onDeleteLecture (index) {
      if (!confirm('능력단위를 삭제할까요?')) return
      this.ncstraining.ncsSpecials.splice(index, 1)
      await this.ncstraining.save()
    },
    onActiveTab (index) {
    }
  }
}
</script>
